/* models/axes/linear_axis */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var axis_1 = require(82) /* ./axis */;
    var continuous_axis_1 = require(84) /* ./continuous_axis */;
    var basic_tick_formatter_1 = require(107) /* ../formatters/basic_tick_formatter */;
    var basic_ticker_1 = require(225) /* ../tickers/basic_ticker */;
    var LinearAxisView = /** @class */ (function (_super) {
        tslib_1.__extends(LinearAxisView, _super);
        function LinearAxisView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        LinearAxisView.__name__ = "LinearAxisView";
        return LinearAxisView;
    }(axis_1.AxisView));
    exports.LinearAxisView = LinearAxisView;
    var LinearAxis = /** @class */ (function (_super) {
        tslib_1.__extends(LinearAxis, _super);
        function LinearAxis(attrs) {
            return _super.call(this, attrs) || this;
        }
        LinearAxis.initClass = function () {
            this.prototype.default_view = LinearAxisView;
            this.override({
                ticker: function () { return new basic_ticker_1.BasicTicker(); },
                formatter: function () { return new basic_tick_formatter_1.BasicTickFormatter(); },
            });
        };
        LinearAxis.__name__ = "LinearAxis";
        return LinearAxis;
    }(continuous_axis_1.ContinuousAxis));
    exports.LinearAxis = LinearAxis;
    LinearAxis.initClass();
}
